import { useEffect, useState } from 'react';

/**
 * The value once it has stopped changing for `ms`. Used for the live calculation and the people
 * search, so typing doesn't send a request per keystroke.
 */
export function useDebounced<T>(value: T, ms: number): T {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const timer = window.setTimeout(() => {
      setSettled(value);
    }, ms);
    return () => {
      window.clearTimeout(timer);
    };
  }, [value, ms]);
  return settled;
}
